import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SubmitSurveyRPC } from "./submitSurveyRPC";

export class SubmitSurveyRPCClientImpl extends SubmitSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SubmitSurveyRPC.Request): Promise<LeoRPCResult<SubmitSurveyRPC.Response, SubmitSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/SubmitSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SubmitSurveyRPC.ResponseDTO,
      SubmitSurveyRPC.Errors.ErrorsDTO,
      SubmitSurveyRPC.Response,
      SubmitSurveyRPC.Errors.Errors
    >(
      response,
      "survey-respondent/SubmitSurvey",
      SubmitSurveyRPC.Response.fromDTO,
      SubmitSurveyRPC.Errors.fromDTO
    );
  }
}
